<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="emailCampaigns">
        <template #default="dataTableProps">
          <EmailCampaignListItem
            :email-campaign="dataTableProps.item"
            @deleted="dataIteratorProps.resetList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountEmailCampaignsClient } from '@/api/clients';
import EmailCampaignListItem from './EmailCampaignListItem.vue';

export default {
  components: {
    EmailCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      emailCampaigns: [],
    };
  },
  watch: {
    '$route.query': {
      handler(query) {
        if (query.email_campaign_updated) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    fetchData() {
      return accountEmailCampaignsClient
        .list(this.accountId, {
          include: ['emailAddressesCount', 'emailAddressesSentCount', 'emailAddressesFailedCount'],
        })
        .then((response) => {
          this.emailCampaigns = response.data;

          return Promise.resolve(response);
        });
    },
  },
};
</script>
